import CONSTANTS from '../../lib/constants';
import { getLibraryPrefix } from '../../utils';

let UTILS = {};

UTILS.cleanElementsClass = function (array, className) {
  [].forEach.call(array, (item) => {
    item.classList.remove(className);
  });
};

UTILS.setElementsAttribute = function (array, attr, value) {
  [].forEach.call(array, (item) => {
    item.setAttribute(attr, value);
  });
};

UTILS.getElementWithClass = function (array, className) {
  let item;
  for (let i = 0; i < array.length; i++) {
    if (array[i].classList.contains(className)) item = array[i];
  }

  return item;
};

UTILS.getClosest = function (elem, selector) {
  for (; elem && elem !== document; elem = elem.parentNode) {
    if (elem.matches(selector)) return elem;
  }
  return null;
};

UTILS.scrollTo = function (element, id) {
  let container = document.getElementById(id);
  // windowTop from https://stackoverflow.com/a/14384091/217866
  let windowTop = window.pageYOffset || document.documentElement.scrollTop;
  let containerHeight = container.offsetHeight;
  let containerTop = container.getBoundingClientRect().top + windowTop;
  let containerBottom = containerTop + containerHeight;
  let elementHeight = element.offsetHeight;
  let elementTop = element.getBoundingClientRect().top + windowTop;
  let elementBottom = elementTop + elementHeight;
  let newScrollTop = elementTop - containerTop + container.scrollTop;

  if (elementTop < containerTop) {
    // scroll up
    container.scrollTop = newScrollTop;
  } else if (elementBottom > containerBottom) {
    // scroll down
    let heightDifference = containerHeight - elementHeight;
    container.scrollTop = newScrollTop - heightDifference;
  }
};

UTILS.isVisible = (elem) =>
  !!elem &&
  !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);

UTILS.swapElements = function (obj1, obj2) {
  // save the location of obj2
  let parent2 = obj2.parentNode;
  let next2 = obj2.nextSibling;
  // special case for obj1 is the next sibling of obj2
  if (next2 === obj1) {
    // just put obj1 before obj2
    parent2.insertBefore(obj1, obj2);
  } else {
    // insert obj2 right before obj1
    obj1.parentNode.insertBefore(obj2, obj1);

    // now insert obj1 where obj2 was
    if (next2) {
      // if there was an element after obj2, then insert obj1 right before that
      parent2.insertBefore(obj1, next2);
    } else {
      // otherwise, just append as last child
      parent2.appendChild(obj1);
    }
  }
};

UTILS.getMonthsAndYears = function () {
  let year = new Date().getFullYear();
  let range = [];
  range.push(year.toString());
  for (let i = 1; i < 20; i++) {
    range.push((year + i).toString());
  }
  let months = [
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
  ];
  return { years: range, months: months };
};

UTILS.checkForDirtyFields = function (form) {
  let dirtyFields = 0;
  angular.forEach(form, function (ctrl, name) {
    // ignore angular fields and functions
    if (name.indexOf('$') !== 0) {
      if (ctrl.$dirty) dirtyFields++;
    }
  });

  return dirtyFields;
};

UTILS.fixCCTypeName = function (type) {
  if (type) {
    type = type.toLowerCase().replace(/\s+/g, '');

    if (type === 'dinersclub') type = 'diners';

    if (type === 'americanexpress') type = 'amex';

    if (type === 'mastercard') type = 'mc';

    return type;
  }

  return '';
};

UTILS.maskStringToShow = function (string, size) {
  return new Array(size).join('*') + string;
};

UTILS.cleanForm = function (form) {
  angular.forEach(form, function (ctrl, name) {
    // ignore angular fields and functions
    if (name.indexOf('$') !== 0) {
      ctrl.$setValidity('validationError', null);
      ctrl.$setValidity('pattern', null);
    }
  });
};

UTILS.setErrors = function (errors, form) {
  let errorObj = {};
  angular.forEach(errors, function (value) {
    if (value.field === 'postalCode') {
      form['someCode'].$error.validationError = true;
      form['someCode'].$setValidity('validationError', false);
    } else if (value.field === 'city') {
      form['someCity'].$error.validationError = true;
      form['someCity'].$setValidity('validationError', false);
    } else if (value.field === 'street') {
      form['someS'].$error.validationError = true;
      form['someS'].$setValidity('validationError', false);
    } else {
      form[value.field].$error.validationError = true;
      form[value.field].$setValidity('validationError', false);
    }
    errorObj[value.field] = value.message;
  });

  return errorObj;
};

function disposeModal($modal) {
  const cssClassPrefix = getLibraryPrefix($modal);
  $modal.removeClass(`${cssClassPrefix}-modal--open`);
  $('body').removeClass('modal--open');
}

function openModal($modal) {
  const cssClassPrefix = getLibraryPrefix($modal);
  $modal.addClass(`${cssClassPrefix}-modal--open`);
  $('body').addClass('modal--open');
}

UTILS.initModal = function () {
  $('.js-show-vk-popup a').click(function (e) {
    e.preventDefault();
    e.stopPropagation();
    let $modal = $('.js-vk-boxmodal');
    openModal($modal);
  });

  $(`.${CONSTANTS.UI_LIBRARY_PREFIX}-modal__content`).click(function (e) {
    e.stopPropagation();
  });

  $('.js-close-modal').click(function (e) {
    e.preventDefault();
    let $modal = $(this).closest(`.${CONSTANTS.UI_LIBRARY_PREFIX}-modal`);
    disposeModal($modal);
  });
};

UTILS.escapeRegexp = (queryToEscape) => {
  return queryToEscape.replace(/([.?*+^$[\]\\(){}|])/g, '');
};
UTILS.escapeRegexpAdvanced = (queryToEscape) => {
  return queryToEscape.replace(/([?*+^$[\]\\"'=%#@!&~`:><(){}|])/g, '');
};

UTILS.matchAllTerms = function (target, term) {
  let parts = term.split(' ');
  // Remove duplicates and sort by longest word
  parts = removeDuplicates(parts).sort((a, b) => b.length - a.length);
  parts.forEach(function (part) {
    if (part !== '' && part !== '.')
      target = target.replace(
        RegExp(part.replace('.', '\\.'), 'ig'),
        '@<' + (part.length > 1 ? part.capitalize() : part) + '>@'
      );
  });
  return target
    .replace(RegExp('@<', 'ig'), '<span class="bold match">')
    .replace(RegExp('>@', 'ig'), '</span>');
};

const removeDuplicates = (arr) => arr.filter((v, i) => arr.indexOf(v) === i);

export default UTILS;
